import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/auth/LoginPage'));
const RegisterPage = lazy(() => import('../pages/auth/RegisterPage'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const InvestmentsPage = lazy(() => import('../pages/investments/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Admin pages
const AdminLoginPage = lazy(() => import('../pages/admin/LoginPage'));
const AdminDashboardPage = lazy(() => import('../pages/admin/DashboardPage'));
const AdminUsersPage = lazy(() => import('../pages/admin/UsersPage'));
const AdminSharesPage = lazy(() => import('../pages/admin/SharesPage'));
const AdminLoansPage = lazy(() => import('../pages/admin/LoansPage'));
const AdminRepaymentsPage = lazy(() => import('../pages/admin/RepaymentsPage'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/register',
    element: <RegisterPage />
  },
  {
    path: '/dashboard',
    element: <DashboardPage />
  },
  {
    path: '/investments',
    element: <InvestmentsPage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />
  },
  {
    path: '/admin/users',
    element: <AdminUsersPage />
  },
  {
    path: '/admin/shares',
    element: <AdminSharesPage />
  },
  {
    path: '/admin/loans',
    element: <AdminLoansPage />
  },
  {
    path: '/admin/repayments',
    element: <AdminRepaymentsPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
